import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { formatNumberGrouped, formatNumberStripDelimiters } from 'util/formatters/numberFormatter';

import TextInput from 'common/TextInput';
import PopoverTrigger from 'triggers/PopoverTrigger';
import Keypad from 'edit/ZoneProductApplicationInputKeypadConnect';

const baseString = 'vra-zone-product-application-input';
const ZoneProductApplicationInputAppMode = ({
  activeKeypad = {},
  applicationType,
  onBlur,
  onChange,
  onClick,
  onClose,
  property,
  validationResult,
  value,
  zoneId,
  showKeypad,
  popoverClassName
}) => {
  const classString = classNames({
    [`${baseString}`]: true
  });

  const { applicationType: keypadApplicationType, property: keypadProperty, zoneId: keypadZoneId} = activeKeypad;
  const keypadIsVisible = (keypadApplicationType === applicationType
    && keypadProperty === property
    && keypadZoneId === zoneId) || showKeypad;

  const input = (
    <TextInput
      className={`${baseString}__input`}
      dataTestId={`${baseString}__input`}
      id={`${baseString}-${zoneId}--${property}`}
      onBlur={onBlur}
      onClick={(e) => {
        e.preventDefault();
        onClick({ applicationType, property });
      }}
      readOnly
      validationResult={validationResult}
      value={formatNumberGrouped(value)}
    />
  );

  const keypadPopover = (
    <Keypad
      accessInputValue={() => document.querySelector(`#${baseString}-${zoneId}--${property}`).value}
      onChange={(newValue) => onChange({
        property,
        value: formatNumberStripDelimiters(newValue ? newValue : 0) })}
      onClose={onClose}
    />
  );

  return (
    <section className={classString}>
      <PopoverTrigger
        canCloseOnClickOff={true}
        className={baseString}
        onHideCallback={(e) => { onClose({ revert: true, target: e.target }); }}
        popoverClassName={popoverClassName}
        popoverContent={keypadPopover}
        popoverIsOpen={keypadIsVisible}
        popoverName='keypad'
        popoverPlacement='right'
        trigger={input}
      />
    </section>
  );
};
ZoneProductApplicationInputAppMode.propTypes = {
  activeKeypad: propTypes.object,
  applicationType: propTypes.string.isRequired,
  className: propTypes.string,
  keypadClassName: propTypes.string,
  onBlur: propTypes.func,
  onChange: propTypes.func.isRequired,
  onClick: propTypes.func.isRequired,
  onClose: propTypes.func.isRequired,
  popoverClassName: propTypes.string,
  property: propTypes.string.isRequired,
  showKeypad: propTypes.bool,
  validationResult: propTypes.object,
  value: propTypes.oneOfType([propTypes.number, propTypes.string]),
  zoneId: propTypes.string.isRequired
};
export default ZoneProductApplicationInputAppMode;
